import {extendObservable, action, toJS} from 'mobx';


class Notifications {
  constructor() {
    extendObservable(this, {
      notification_items: [],
      error: undefined,

      addNotification: action((values) => {
        values.forEach(i => {
          var id =  +new Date()
          this.notification_items.push({
            id: id,
            message: i.message,
            duration: i.duration || 5000,
            type: i.type,
          })

          setTimeout(() => {
            this.notification_items = this.notification_items.filter((item) => item.id !== id)
          }, i.duration || 5000)
        })

      }),

      removeNotification: action((id) => {
        this.notification_items = this.notification_items.filter((item) => item.id !== id)
      }),

      get items() {
        return toJS(this.notification_items);
      },

    })
  }
}

export default new Notifications()
